// extracted by mini-css-extract-plugin
export var container = "_ch-0";
export var infoIcon = "_ch-2";
export var titleRowCol = "_ch-1";